import { Routes } from '@angular/router';
import { LoginComponent } from '../app/pages/login/login.component';
import { MainLayoutComponent } from '../app/layouts/main-layout';
import { DashboardComponent } from '../app/pages/dashboard/dashboard.component';
import { authGuard } from './auth/auth.guard';


export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },

  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        title: 'Dashboard'
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
